import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { db } from "../utility/firebase";
import {
  serverTimestamp,
  doc,
  setDoc,
  getDoc,
  deleteDoc,
  updateDoc,
  arrayRemove,
} from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { myFetchPost, apiUrl, getMobileOperatingSystem, getCookie, appVersion } from "../utility";
import "../css/ChatRoomDropDown.css";

const ChatRoomDropDown = (props) => {
  const { targetUserId, currentChatRoomId, chatUserData } = props;
  const { currentUser } = useAuth();

  const theRef = useRef();

  const [showMenu, setShowMenu] = useState(null);

  const [isBlocked, setIsBlocked] = useState(false);

  const [showReportModal, setShowReportModal] = useState(false);
  const [showReportSuccessModal, setShowReportSuccessModal] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showFeedbackSuccessModal, setShowFeedbackSuccessModal] = useState(false);

  const [showBlockUserModal, setShowBlockUserModal] = useState(false);
  const [showBlockUserSuccessModal, setShowBlockUserSuccessModal] = useState(false);

  const [showRemoveModal, setShowRemoveModal] = useState(false);

  /* show isBlocked modal */
  const [showIsBlockedModal, setShowIsBlockModal] = useState(false);

  /* report form value */
  const [reportReason, setReportReason] = useState(0);
  const [reportMessage, setReportMessage] = useState("");
  const [feedbackMessage, setFeedbackMessage] = useState("");

  useEffect(() => {
    if (showMenu == true) {
      document.addEventListener("click", closeMenuNow);
    } else if (showMenu == false) {
      document.removeEventListener("click", closeMenuNow);
    }
    return () => {
      document.removeEventListener("click", closeMenuNow);
    };
  }, [showMenu]);

  const showMenuNow = (e) => {
    setShowMenu(!showMenu);
  };

  const closeMenuNow = (e) => {
    if (!theRef.current?.contains(e.target)) {
      setShowMenu(false);
    }
  };

  /* check if this user is blocked */
  useEffect(() => {
    if (targetUserId) {
      getDoc(doc(db, "user", currentUser.uid, "blocklist", targetUserId)).then(
        (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data({ serverTimestamps: "estimate" });
            if (data.blocked) {
              setIsBlocked(true);
              setShowIsBlockModal(true);
            } else {
              setIsBlocked(false);
              setShowIsBlockModal(false);
            }
          } else {
            setIsBlocked(false);
            setShowIsBlockModal(false);
          }
        }
      );
    }
  }, [targetUserId]);

  const navigate = useNavigate();

  const handleReportReasonChange = (e) => {
    setReportReason(e.target.value);
  };

  const handleReportMessageChange = (e) => {
    setReportMessage(e.target.value);
  };

  const handleFeedbackMessage = (e) => {
    setFeedbackMessage(e.target.value);
  };

  const handleToggleBlock = async () => {
    try {
      // Add a new document in collection "blockList"
      if (!isBlocked) {
        await setDoc(
          doc(db, "user", currentUser.uid, "blocklist", targetUserId),
          {
            blocked: !isBlocked,
            blockTime: serverTimestamp(),
          },
          { merge: true }
        );
      } else {
        await deleteDoc(
          doc(db, "user", currentUser.uid, "blocklist", targetUserId)
        );
      }
      setIsBlocked(!isBlocked);
      setShowBlockUserModal(false);
      setShowBlockUserSuccessModal(true);
    } catch (error) {
      //alert(error);
    }
  };

  const handleRemoveChat = async () => {
    /* need to present a Modal Dialog Asking the user to confirm */
    setShowRemoveModal(false);
    try {
      await updateDoc(doc(db, "chatRooms", currentChatRoomId), {
        activeMembers: arrayRemove(currentUser.uid),
      });
      navigate("/");
    } catch (error) {
      alert('未能成功刪除對話, 請回報此問題');
    }
  };

  const handleReport = async () => {
    // Validate reportReason and reportMessage
    if (!reportReason || reportReason === "0") {
      alert("請選擇檢舉原因");
      return;
    }
    if (!reportMessage.trim()) {
      alert("請輸入檢舉訊息");
      setTimeout(() => {
        const input = document.querySelector('textarea[name="report_message"]');
        if (input) input.focus();
      }, 0);
      return;
    }
    try {
      const token = await currentUser.getIdToken();
      // Map reportReason index to text
      let reportReasonText = "";
      switch (reportReason) {
        case "1":
          reportReasonText = "懷疑詐騙";
          break;
        case "2":
          reportReasonText = "不禮貌言語";
          break;
        case "3":
          reportReasonText = "不當內容";
          break;
        case "99":
          reportReasonText = "其他";
          break;
        default:
          reportReasonText = "";
      }
      const requestData = {
        targetUserId: targetUserId,
        chatRoomId: currentChatRoomId,
        reportReason: reportReasonText,
        reportMessage: reportMessage,
      };
      await myFetchPost(`${apiUrl}/chat/report`, requestData, {
        Authorization: "Bearer " + token,
      });
      setReportMessage("");
      setReportReason(0);
      setShowReportModal(false);
      setShowReportSuccessModal(true);
    } catch (error) {
      alert(error);
    }
  };

  const handleFeedback = async () => {
    const os = getMobileOperatingSystem();
    // Focus the feedback input if empty
    if (!feedbackMessage.trim()) {
      alert("請輸入回報訊息");
      setTimeout(() => {
        const input = document.querySelector('textarea[name="report_message"]');
        if (input) input.focus();
      }, 0);
      return;
    }

    try {
      const token = await currentUser.getIdToken();
      const requestData = {
        chatRoomId: currentChatRoomId,
        feedbackMessage: feedbackMessage,
        os: os,
        appVersion: appVersion,
        deviceId: getCookie("dcff_psid") || "",
      };

      await myFetchPost(`${apiUrl}/chat/feedback`, requestData, {
        Authorization: "Bearer " + token,
      });
      setFeedbackMessage("");
      setShowFeedbackModal(false);
      setShowFeedbackSuccessModal(true);
    } catch (error) {
      alert(error);
    }
  }

  return (
    <div className="chatRoomDropDownWrap" ref={theRef}>
      <div onClick={showMenuNow} className="chatRoomDropDown">
        <i className="openDropDown bi bi-three-dots-vertical"></i>
        <span>管理<span className="desktopText">對話</span></span>
      </div>
      {showMenu && (
        <div className="menuWrap">
          <div className="menu">
            <div
              onClick={() => {
                setShowMenu(false);
                setShowReportModal(true);
              }}
              className="menuItem"
            >
              檢舉此對話／會員
            </div>
            <div
              onClick={() => {
                setShowMenu(false);
                setShowBlockUserModal(true);
                //handleToggleBlock();
              }}
              className="menuItem"
            >
              {isBlocked ? "解除封鎖用戶" : "封鎖用戶"}
            </div>
            <div
              onClick={() => {
                setShowMenu(false);
                setShowRemoveModal(true);
              }}
              className="menuItem"
            >
              刪除對話
            </div>
            <div
              onClick={() => {
                setShowMenu(false);
                setShowFeedbackModal(true);
              }}
              className="menuItem"
            >
              回報問題
            </div>
          </div>
        </div>
      )}
      {/* Feedback */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showFeedbackModal}
        onHide={() => {
          setShowFeedbackModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>回報問題</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ fontSize: 15 }}>
            <div style={{ marginBottom: 15, fontSize: 15 }}>如有任何問題，請回報給我們！<br />我們會盡快處理。</div>
            <span style={{ display: "inline-block", marginBottom: 2, fontWeight: 600 }}>回報訊息：</span>
            <textarea name="feedback_message" style={{ minHeight: 50, width: '100%' }} className="messageInputBox form-control" value={feedbackMessage} onChange={handleFeedbackMessage}></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowFeedbackModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleFeedback();
            }}
          >
            立即回報
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal

        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showFeedbackSuccessModal}
        onHide={() => {
          setShowFeedbackSuccessModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>回報成功</Modal.Title>
        </Modal.Header>
        <Modal.Body>感謝你的回報，我們會盡快處理。</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowFeedbackSuccessModal(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Report this user */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showReportModal}
        onHide={() => {
          setShowReportModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>檢舉此對話／會員</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ fontSize: 15 }}>
            <div style={{ marginBottom: 15, fontSize: 15 }}>如有懷疑，請立即檢舉！<br />共創一個安全的交易環境！</div>
            <span style={{ display: "inline-block", marginBottom: 2, fontWeight: 600 }}>檢舉原因：</span>
            <select name="report_reason" style={{ width: '100%', marginBottom: 12 }} class="form-select" onChange={handleReportReasonChange} value={reportReason}>
              <option value="0">--</option>
              <option value="1">懷疑詐騙</option>
              <option value="2">不禮貌言語</option>
              <option value="3">不當內容</option>
              <option value="99">其他</option>
            </select>
            <span style={{ display: "inline-block", marginBottom: 2, fontWeight: 600 }}>檢舉訊息：</span>
            <textarea name="report_message" style={{ minHeight: 50, width: '100%' }} class="messageInputBox form-control" value={reportMessage} onChange={handleReportMessageChange}></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowReportModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleReport();
            }}
          >
            立即檢舉
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showReportSuccessModal}
        onHide={() => {
          setShowReportSuccessModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>檢舉成功</Modal.Title>
        </Modal.Header>
        <Modal.Body>感謝你的回報，這將有助於我們維護平台的安全。</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowReportSuccessModal(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Block User */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showBlockUserModal}
        onHide={() => {
          setShowBlockUserModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{isBlocked ? "解除封鎖用戶" : "封鎖用戶"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isBlocked ? (
            <div>你是否確認解除封鎖此用戶? 解除後，你將可以再次接收對方的訊息。</div>
          ) : (
            <div>你是否確認封鎖此用戶? 封鎖後，你將不會再接收對方的訊息。</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowBlockUserModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleToggleBlock();
            }}
          >
            {isBlocked ? "解除封鎖" : "封鎖用戶"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showBlockUserSuccessModal}
        onHide={() => {
          setShowBlockUserSuccessModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{!isBlocked ? "解除封鎖成功" : "封鎖成功"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!isBlocked ? (
            <div>你已成功解除封鎖此用戶。</div>
          ) : (
            <div>你已成功封鎖此用戶。你將不會再接收對方的訊息。</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowBlockUserSuccessModal(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Remove the chatRoom */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showRemoveModal}
        onHide={() => {
          setShowRemoveModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>刪除對話</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          你是否確認永久刪除此對話? 如果你不想接收到對方的對話訊息,
          你可以點擊「封鎖用戶」把用戶封鎖。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowRemoveModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleRemoveChat();
            }}
          >
            立即刪除對話
          </Button>
        </Modal.Footer>
      </Modal>

      {/* user isBlocked Modal */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showIsBlockedModal}
        onHide={() => {
          setShowIsBlockModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>用戶已被你封鎖</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          你已經封鎖了「{chatUserData.username}」。你將不會再接收對方的訊息。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowIsBlockModal(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ChatRoomDropDown;
